// Kept free of imports: phone-reducer reads this, and the selectors lead back to configure-store.

/** The bag variable the companion reports its microphone state in. */
export const COMPANION_LOCALLY_MUTED = 'telavox.companion.locally-muted';
